<template>
  <div>
    <v-card
      color='primary'>
      <v-layout
        column
        fill-height>
        <v-card-title
          class="white--text pl-5 pt-5">
          <v-spacer>Payment</v-spacer>
        </v-card-title>
      </v-layout>
      <v-list two-line>
        <v-card-text
          class="pa-10">
          <center>
            <h1>Select Plan</h1>
          </center>
          <v-item-group
            v-model="selected">
            <v-container>
              <v-row>
                <v-col
                  v-for="(item, i) in purchaseOptions"
                  :key="i"
                  md="4">
                  <v-item
                    v-slot:default="{ active, toggle }">
                    <v-card
                      :color="active ? 'primary' : 'grey'"
                      class="d-flex align-center"
                      dark
                      height="100"
                      @click="select(i, item)">
                      <div
                        class="flex-grow-1 text-center">
                        {{item.title}}
                      </div>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>

          <br>

          <div
            v-show="plan.title === 'Concierge'">
            <p>
              Please contact us about this plan.
              <br/>
              You can call us at (844) 743-6384 or email at info@genetictrust.com
            </p>
          </div>

          <div
            v-show="plan.title !== 'Concierge'">

            <center>
            <h1>Is this a couple plan? (For 2 adults)</h1>
            </center>
            <v-radio-group v-model="couple" :mandatory="true">
              <v-radio label="Yes" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>

            <br>

            <h3
              v-if="plan.price_1 || plan.price_2">
              Price: {{couple ? plan.price_2 : plan.price_1}}
            </h3>

            <br>

            <div ref="card"></div>
          </div>
        </v-card-text>
      </v-list>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          color="primary"
          justify="right"
          @click="activateDialog=true">
          Activation Code
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          justify="right"
          @click="cancel">
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          justify="right"
          @click="submit">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model='activateDialog'
      max-width="500px"
      persistent>
      <v-card>
        <v-card-text
          class="pa-10">
          Please input the activation code here.
          <v-text-field
            v-model='activateCode'></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            justify="right"
            @click="activateDialog=false">
            Close
          </v-btn>
          <v-btn
            color="primary"
            justify="right"
            @click="activate">
            Activate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model='confirmDialog'
      max-width="500px"
      persistent>
      <v-card>
        <v-card-text
          class="pa-10">
          Thank you for signing up to the Genetic Trust!
          <br/><br/>
          A receipt has been sent to your email.
          <br/><br/>
          <div
            v-if='couple'>
            You will also be receiving an email with your partners activation code. Make sure to store the code for when they create their account.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            justify="right"
            @click="confirm">
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapFields } from 'vuex-map-fields';
  import axios from 'axios';
  import router from '@/router';
  import { stripePayment, activateAccount } from '../helper/firestore'

  let stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY),
      elements = stripe.elements(),
      card = undefined;

  var style = {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '22px',
      '::placeholder': {
        color: '#aab7c4'
      }
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  }

  export default {
    props: {
      modal: Boolean
    },
    components: {
    },
    data () {
      return {
        purchaseOptions: [
          { title: "Plus", price_1: "$399.00", price_2: "$599.00", value: "p1" },
          { title: "Complete", price_1: "$599.00", price_2: "$899.00", value: "p2" },
          { title: "Concierge", price_1: "", price_2: "", value: "p3" },
        ],
        confirmDialog: false,
        activateDialog: false,
        activateCode: '',
        couple: false,
        selected: 0,
        plan: {}
      }
    },
    mounted() {
      card = elements.create('card', {style: style});
      this.selected = this.selectedPlan;
      card.mount(this.$refs.card);
      this.plan = this.purchaseOptions[this.selected];
    },
    methods: {
      cancel() {
        router.replace('/public/home');
      },
      submit() {
        var email = this.user.info.email;
        var plan = this.plan.value;
        if (this.couple) {
          plan += '_couple';
        }
        stripePayment(stripe, card, email, plan, (res) => {
          if (res.status === 200) {
            this.user.plan = plan;
            this.confirmDialog = true;
          } else {
            this.snackBarmessage = "Payment processing error"
            this.snackBarType = "warning"
            this.snackBarshow =true
          }
        });
      },
      activate() {
        activateAccount(this.activateCode, (res) => {
          if (res.status === 200) {
            this.user.plan = res.data.plan
            this.isAuthorized = true;
            router.replace('/home');
          } else {
            this.snackBarmessage = "Invalid activation code"
            this.snackBarType = "warning"
            this.snackBarshow =true
          }
        })
      },
      confirm() {
        this.isAuthorized = true;
        router.replace('/home');
      },
      select(i, item) {
        this.selected = i;
        this.plan = item;
      }
    },
    computed: {
      ...mapFields([
        'user',
        'isAuthorized',
        'snackBarshow',
        'snackBarType',
        'snackBarmessage',
      ]),
      ...mapFields("patientQuestion", [
        "selectedPlan"
      ]),
    }
  }
</script>
<style>
.v-card__text, .v-card__title {
  word-break: normal; /* maybe !important  */
}

.mainHov {
  transition: opacity 0.4s ease-in-out;
}

.mainHov:not(.on-hover) {
  opacity: 0.6;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>
